/**
 * @module project/components/participate_form/complete_step
 */
import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { getProjectUrl } from 'project/utils';
import NewProjects from 'project/containers/new_projects';

/**
 * Participate upload form step that shows final info after adding new entry to a project
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ParticipateCompleteStep extends Component {
  constructor(props) {
    super(props);
    this.state = { counter: 10 };
    this.decrement = this.decrement.bind(this);
    this.timer = setInterval(this.decrement, 1000);
  }

  decrement() {
    const newCounter = this.state.counter - 1;

    this.setState({ counter: newCounter });

    /* stop timer when it reaches 0 */
    if (newCounter === 0) {
      clearInterval(this.timer);
    }
  }

  render() {
    const { entryType, thumbnail, project, subCategory, onCloseForm } = this.props;
    const myEntriesUrl = getProjectUrl(project, subCategory.slug, 'your-entries/');
    const { counter } = this.state;
    const isImage = entryType === 'image';

    return (
      <div className="participate-step complete-step">
        <div className="modal-header">
          <h5>{isImage? 'Uploading' : 'Processing'} your entry...</h5>
        </div>
        <div className="modal-content">
          <div className="row expanded collapse">
            <div className="medium-12 columns">
              <h2>Please wait a few seconds.</h2>
              <p>
                Your {isImage? 'image' : 'entry'} is in the queue and is
                being {isImage? 'uploaded' : 'processed'}.</p>
              <h3>What happens next?</h3>
              <p>
                We&apos;ll notify you when the client scores or comments on your entry,<br/>
                updates the brief, or selects a winner. In the meantime, here are some<br/>
                NEW projects that might interest you:
              </p>
              <NewProjects />
            </div>

            { isImage &&
            <div className="medium-4 columns">
              <div className="participate-sidebar">

                <div className="entry-image">
                  <img className="thumbnail-wrap" src={thumbnail} alt="submitted entry" />
                </div>

                {/* @TODO add sharing options */}
              </div>
            </div> }
          </div>
          <div className="modal-actions">
            <Link onClick={onCloseForm} to={myEntriesUrl}
                className={"btn btn-primary" + (counter > 0? " disabled" : "")}>
              { counter > 0? `Please wait ${counter}s` : 'Done' }
            </Link>
          </div>
        </div>
      </div>);
  }
}

ParticipateCompleteStep.propTypes = {
  project: PropTypes.object,
  subCategory: PropTypes.object,
  entryType: PropTypes.string,
  thumbnail: PropTypes.string,
  onCloseForm: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/participate_form/complete_step.jsx